import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Brackets } from "lucide-react";

const DEFAULT_VARIABLES = [
  { name: "firstname", description: "Contact's first name" },
  { name: "lastname", description: "Contact's last name" },
  { name: "companyname", description: "Contact's company name" },
  { name: "occupation", description: "Contact's job title/occupation" },
  { name: "email", description: "Contact's email address" },
  { name: "phone", description: "Contact's phone number" }
];

interface VariableSelectorProps {
  onSelect: (variable: string) => void;
}

export function VariableSelector({ onSelect }: VariableSelectorProps) {
  return (
    <Select
      onValueChange={(value) => onSelect(`{{${value}}}`)}
    >
      <SelectTrigger className="w-[180px]">
        <Brackets className="h-4 w-4 mr-2" />
        <SelectValue placeholder="Insert variable" />
      </SelectTrigger>
      <SelectContent>
        {DEFAULT_VARIABLES.map((variable) => (
          <SelectItem 
            key={variable.name} 
            value={variable.name}
          >
            <div className="flex flex-col">
              <span>{variable.name}</span>
              <span className="text-xs text-muted-foreground">
                {variable.description}
              </span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}